const dev = {
    apiGateway: {
        REGION: "TR",
        URL: "http://localhost",
        PORT: "2096",
        AUTOMMATE_API_HOST: "http://78.141.212.117",
        AUTOMMATE_API_PORT: "2096"
    }
};
const test = {
    apiGateway: {
        REGION: "TR",
        URL: "http://78.141.212.117",
        PORT: "2096",
        AUTOMMATE_API_HOST: "http://78.141.212.117",
        AUTOMMATE_API_PORT: "2096"
    }
};
const prod = {
    apiGateway: {
        REGION: "TR",
        URL: "http://78.141.212.117",
        PORT: "2096",
        AUTOMMATE_API_HOST: "http://78.141.212.117",
        AUTOMMATE_API_PORT: "2096"
    }
};

const config = process.env.REACT_APP_STAGE === 'production'
    ? prod
    : process.env.REACT_APP_STAGE === 'test'
        ? test
        : dev;

export default {
    // Add common config values here
    MAX_ATTACHMENT_SIZE: 5000000,
    ...config
};
